@if (!isAuthorized()) {
<button mat-raised-button (click)="signInWithGoogle()">
  Sign in with Google
</button>
} @if (isAuthorized()) {
<app-inverted-stroked-button (click)="signOut()">
  Sign out
</app-inverted-stroked-button>
}
